import { SessionKvKey } from "../../api/features/session-kv";
import useSessionValue from "../session-kv/useSessionValue";

export function useActiveDialog() {
  const { value, setValue } = useSessionValue<boolean>(
    SessionKvKey.ACTIVE_DIALOG
  );

  return { activeDialog: value, setActiveDialog: setValue };
}
